export const fixedAssets = {
    namespaced: true,
    state: {
        warehouseId: 0,
    },
    getters: {
        warehouseId(state) {
            return state.warehouseId
        },
    },
    mutations: {
        setWarehouseId(state, warehouseId) {
            state.warehouseId = warehouseId
        },
    },
    actions: {
        
    }
}